import config from './config';
import Swal from 'sweetalert2';

const axios = require('axios');


const apiService = axios.create({
    baseURL: config.apiUrl,
    withCredentials: true
});
apiService.defaults.headers.common['Authorization'] = config.token;

apiService.interceptors.response.use(res => res,
    err => {
        if (err.response.status == 401) {
            Swal.fire({
                text: 'Usuario sin autorización (401)',
                icon: 'warning',
                confirmButtonText: 'OK'
            })
                .then((result) => {
                    location.reload();
                });
        }
        return Promise.reject(err);
    });

window.addEventListener('offline', function (e) {
    Swal.fire({
        title: 'Error de red',
        text: 'En este momento no tienes conexión.',
        icon: 'warning',
        confirmButtonText: 'OK'
    })
        .then((result) => {

        });
});

window.addEventListener('online', function (e) {
    Swal.fire({
        text: 'Se ha restablecido la conexión a internet.',
        icon: 'success',
        confirmButtonText: 'OK'
    })
        .then((result) => {

        });
});

export default apiService;
